import {ChoiceList, ChoiceRow, ModalShell} from './ui/ModalShell';

export const AutoExecuteOptionsModal = ({onSelect}) => (
  <ModalShell
    title="Execute orders"
    subtitle="Choose the asset type you are executing against.">
    <ChoiceList>
      <ChoiceRow
        label="Stocks"
        description="Execute a single order, or a bundle from a CSV."
        onClick={() => onSelect('STOCKS')}
      />
      <ChoiceRow
        label="Managed Funds"
        hint="Not yet available"
        disabled
        onClick={() => onSelect('MANAGED_FUNDS')}
      />
      <ChoiceRow
        label="Bonds"
        hint="Not yet available"
        disabled
        onClick={() => onSelect('BONDS')}
      />
    </ChoiceList>
  </ModalShell>
);
